import React, { Component } from 'react';

import App from './App.jsx';

import './css/PopUp.css';

const iconGeocensus = require('../src/css/img/popup/biosense-03.png');

type T_PopUpProps = {
  app: App
}

type T_PopUpState = {
  show: boolean
}

export default class PopUp extends Component<T_PopUpProps, T_PopUpState> {
  componentDidMount() {
    const app = this.props.app;

    if (app.state.show_popup) {
      setTimeout(() => {
        this.classChange();
      }, 5000);
    }
  }

  close = () => {
    this.props.app.setState({ show_popup: false });
  }

  classChange = () => {
    const toggle = document.getElementById('popupToggle');
    toggle !== null ? toggle.classList.toggle('closed') : console.log('toggle es null');

    const arrow = document.getElementById('arrowToggle');
    arrow !== null ? arrow.classList.toggle('open') : console.log('arrow es null');
  }

  render() {
    return (
      <div id="popupToggle" className="popup">
        <div className="popup-arrow">
          <a id="arrowToggle" className="arrow-icon" onClick={this.classChange}>
            <span className="left-bar"></span>
            <span className="right-bar"></span>
          </a>
        </div>
        <div className="popup-text">
          <img src={iconGeocensus} alt="" />
          <p style={{ margin: '10px auto'}}>Conozca más sobre este práctico servicio de sensoramiento.</p>
          <p style={{ height: '34px', margin: '5px 0px', fontFamily: 'Raleway-Black' }}><a href="mailto:contacto@agrosat.cl?bcc=pablo.merino@agrosat.cl">Más información</a></p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/PopUp.jsx